import { Outlet } from 'react-router-dom'
import { Stack, Container } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import useOffSetTop from '../../hooks/useOffSetTop'
import { HEADER } from '../../config-global'
import Header from './Header'
import { useDomainContext } from '../../contexts/DomainContext'

export default function ContentLayout() {

    const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP)
    const { sucursal } = useDomainContext()

    return (
        <>
            {!!sucursal?.sc_css && (
                <Helmet>
                    <link rel="stylesheet" type="text/css" href={`/css/${sucursal?.sc_css}`} />
                </Helmet>
            )}
            <Header isOffset={isOffset} />
            <Container id="app-container" component="main">
                <Stack
                    sx={{
                        py: 12,
                        minHeight: '100vh',
                    }}
                >
                    <Outlet />
                </Stack>
            </Container>
        </>
    );
}
